<template>
<div :class="bem()" :style="`padding:0px ${vm.width < 400? 40: 80}px`">
    <div :class="bem('title')">
        绑定手机号
        <div :class="bem('desc')" >您好，尊敬的 “{{bindInfo.org_name}}” 用户<br/><strong>您首次授权登录</strong>  请您完善登录账号信息!</div>
    </div>
    <div :class="bem('item')">
        <PhoneNumber
            v-model="vm.form.phone"
            :countries="vm.countries"
            :loading="checkingPhone"
        />
    </div>
    <div :class="bem('item')">
        <Input
            v-model="vm.form.verifyCode"
            maxlength="6"
            type="text"
            autocomplete="off"
            placeholder="输入验证码"/>
        <!-- FIXME: 更好的方式处理自动填充问题 -->
        <Input style="display:none" type="password" autocomplete="new-password" />
        <verifyCode
            :sendVerifyCode="sendVerifyCode"
            type="login"/>
    </div>

    <Button
        type="primary"
        size="large"
        :class="bem('submit')"
        @click="onBindPhone"
        nativeType="submit"
        :disabled="loading">登录</Button>
</div>

</template>
<script>
import _Dialog from "@gaoding/gdui/lib/dialog";
import _Input from "@gaoding/gdui/lib/input";
import _Button from "@gaoding/gdui/lib/button";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import PhoneNumber from './phone-number/index.vue';
import verifyCode from './verify-code.vue';
import bemMixin from './bem';
import guestUser from './guestUser';
import { getConfig } from './config';
import { LOGIN_TYPE } from './constants';
import { checkPhoneNumber, checkCaptcha } from './utils';
export default {
  name: 'g-auth-bindphone',
  components: {
    Button: _Button,
    PhoneNumber: PhoneNumber,
    Input: _Input,
    verifyCode: verifyCode
  },
  mixins: [bemMixin],
  inject: ['vm'],
  props: {
    bindInfo: {
      type: Object,
      default: function _default() {
        return {
          uuid: '',
          org_name: ''
        };
      }
    }
  },
  data: function data() {
    return {
      phoneNumberIsUsed: null,
      needRegister: false,
      phoneCheckStatus: 0,
      checkingPhone: false,
      loading: false
    };
  },
  mounted: function mounted() {
    this.checkIsBinded();
  },
  methods: {
    // TODO: 向商目前只支持校验注册状态，无法区别QQ， Wechat 所以暂时关闭已注册的情况的错误处理
    checkIsBinded: function checkIsBinded() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _yield$_this$vm$reque, result;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.vm.form.phone.number) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _this.checkingPhone = true;
                _context.prev = 3;
                _context.next = 6;
                return _this.vm.requestUms('checkPhoneNumberStatus', _this.vm.form);

              case 6:
                _yield$_this$vm$reque = _context.sent;
                result = _yield$_this$vm$reque.result;
                _this.phoneCheckStatus = result;

                if (!(result === 1)) {
                  _context.next = 16;
                  break;
                }

                _this.vm.$emit('error', {
                  error: new Error('手机号码未注册，填写密码注册'),
                  action: 'login',
                  type: 'bindphone'
                });

                _this.phoneNumberIsUsed = false;
                _this.needRegister = true;
                return _context.abrupt("return");

              case 16:
                if (!(result === 3)) {
                  _context.next = 20;
                  break;
                }

                _this.phoneNumberIsUsed = true;
                _context.next = 25;
                break;

              case 20:
                if (!(result === 2)) {
                  _context.next = 24;
                  break;
                }

                _this.phoneNumberIsUsed = false;
                _context.next = 25;
                break;

              case 24:
                throw new Error('未知错误');

              case 25:
                _this.needRegister = false;
                _context.next = 31;
                break;

              case 28:
                _context.prev = 28;
                _context.t0 = _context["catch"](3);

                _this.vm.$emit('error', {
                  error: _context.t0,
                  action: 'login',
                  type: LOGIN_TYPE.QIYE_WECHAT_BINDPHONE
                });

              case 31:
                _context.prev = 31;
                _this.checkingPhone = false;
                return _context.finish(31);

              case 34:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 28, 31, 34]]);
      }))();
    },
    sendVerifyCode: function sendVerifyCode() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (checkPhoneNumber(_this2.vm.form.phone)) {
                  _context2.next = 2;
                  break;
                }

                throw new Error('请填写正确的手机号码');

              case 2:
                _context2.next = 4;
                return _this2.vm.requestUms('sendQiyeVerifyCode', _objectSpread(_objectSpread({}, _this2.vm.form), {}, {
                  type: 'login'
                }));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    onBindPhone: function onBindPhone() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (checkPhoneNumber(_this3.vm.form.phone, _this3.vm)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                if (checkCaptcha(_this3.vm.form.verifyCode, _this3.vm)) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt("return");

              case 4:
                if (!_this3.loading) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt("return");

              case 6:
                _this3.loading = true;
                _context3.prev = 7;
                _context3.next = 10;
                return _this3.vm.requestUms('qyWechatCheckMobileBind', _objectSpread(_objectSpread(_objectSpread({}, _this3.vm.form), _this3.bindInfo), {}, {
                  guestToken: guestUser.guestfinger,
                  client_id: getConfig('clientId')
                }));

              case 10:
                response = _context3.sent;

                // 企业微信首次授权登录，确认是否使用该手机号
                if (response && response.redirect_code === '40032') {
                  _this3.confirmBindPhone();
                } else {
                  _this3.vm.onLogin(LOGIN_TYPE.QIYE_WECHAT_BINDPHONE);

                  _this3.loading = false;
                }

                _context3.next = 18;
                break;

              case 14:
                _context3.prev = 14;
                _context3.t0 = _context3["catch"](7);
                _this3.loading = false;

                _this3.vm.$emit('error', {
                  action: 'bindphone',
                  type: LOGIN_TYPE.QIYE_WECHAT_BINDPHONE,
                  error: _context3.t0
                });

              case 18:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[7, 14]]);
      }))();
    },
    confirmBindPhone: function confirmBindPhone() {
      var _this4 = this;

      _Dialog.open({
        title: '消息确认',
        content: '确认以此手机号为账号加入到企业中使用相关服务吗？',
        showClose: false,
        okText: '确 定',
        cancelText: '取 消',
        onOk: function onOk() {
          _this4.vm.requestUms('qyWechatMobileBind', _objectSpread(_objectSpread({}, _this4.bindInfo), {}, {
            guestToken: guestUser.guestfinger,
            client_id: getConfig('clientId')
          })).then(function (res) {
            if (res) {
              _this4.vm.onLogin(LOGIN_TYPE.QIYE_WECHAT_BINDPHONE);
            }

            _this4.loading = false;
          });
        },
        onCancel: function onCancel() {
          _this4.loading = false;
        }
      });
    }
  }
};
</script>
<style>
/*
 * @Author: 天吾
 * @Date: 2019-01-23 16:29:55
 * @Last Modified by: 天吾
 * @Last Modified time: 2019-11-22 11:24:33
 */
/*
    size 统一用  sm base lg  表示,  对于不能满足的情况, 仿照衣服尺寸加上 x(EXTRA) 比如  font-size-xlg 表示特大
*/
.g-auth-bindphone {
  line-height: 1.2;
}
.g-auth-bindphone .g-auth-bindphone__title {
  color: #000;
  font-size: 20px;
  font-weight: 600;
  line-height: 20px;
  margin-bottom: 40px;
  align-items: center;
  text-align: center;
}
.g-auth-bindphone .g-auth-bindphone__title span {
  display: block;
  font-weight: 400;
  line-height: 24px;
  margin-top: 16px;
  font-size: 14px;
  text-align: left;
  color: #444950;
}
.g-auth-bindphone .g-auth-bindphone__desc {
  margin-top: 14px;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: #7F8792;
}
.g-auth-bindphone .g-auth-bindphone__desc strong {
  color: #000;
}
.g-auth-bindphone .g-auth-bindphone__item {
  display: flex;
}
.g-auth-bindphone .g-auth-bindphone__item + .g-auth-bindphone__item {
  margin-top: 16px;
}
.g-auth-bindphone__skip {
  font-size: 13px;
  color: #2254F4;
  cursor: pointer;
}
.g-auth-bindphone__submit {
  margin-top: 24px;
  width: 100%;
  height: 45px;
  font-weight: 600;
}
.g-auth-bindphone .g-auth-bindphone__links {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 24px;
  color: #A9A9A9;
}
.g-auth-bindphone .g-auth-bindphone__tips {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  color: #33383E;
  margin-top: 24px;
}
.g-auth-bindphone .g-auth-bindphone__footer {
  position: absolute;
  display: flex;
  justify-content: space-between;
  align-items: center;
  bottom: 0;
  left: 0;
  height: 48px;
  width: 100%;
  padding: 0 20px;
  color: #444950;
  background: linear-gradient(216deg, #f9fafb 0%, #f8fafb 57%, #f0f2f6 100%);
}

</style>
